import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';

function List() {

    const pathFrontEnd = '/cbooccupations/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}cbooccupations/delete`,
        endpoint: config.endpoints.backend + 'cbooccupations/getall'
    }

    let list = {
        labelTitle: 'Lista de Ocupações CBO',
        labelTitleButtonAdd: 'Importar CBO',
        fieldsShowOnDelete: ['title'],
        showPrintButtons: true,
        canEdit: false,
        canDelete: false,
        canView: false,
        viewActionColumn: false,
        columns: [
            {
                name: 'code',
                label: 'Código'
            },
            {
                name: 'title',
                label: 'Título'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
